import React from 'react';

class Contact extends React.Component {
    render() {
        return (
            <div class="bg-stone-900 min-h-52 pt-16 md:pt-28 px-5 md:px-0 md:-mt-32 pb-24" id="contact">
                <div class="container text-center md:text-left text-white p-5 mx-auto md:mt-32">
                    <p class="text-5xl font-extrabold">CONTACT ME</p>

                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <div class="mt-16 md:mt-0 md:p-12 lg:p-24">
                            <img src="/contact.png" class="w-full" alt="icon" />
                        </div>
                        <div>
                            <div class="md:mt-18 lg:mt-24 md:ps-12">
                                <div class="flex">
                                    <div class="w-20">
                                        <img width="50" height="50" src="https://img.icons8.com/dotty/80/FFFFFF/new-post.png" alt="new-post" />
                                    </div>
                                    <div>
                                        <p class="pt-2.5 text-base md:text-xl font-bold tracking-wide text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">lilostellarcomms@gmail.com</p>
                                    </div>
                                </div>
                                <div class="flex">
                                    <div class="w-20">
                                        <img width="50" height="50" src="https://img.icons8.com/dotty/80/FFFFFF/instagram-new.png" alt="instagram-new" />
                                    </div>
                                    <div>
                                        <p class="pt-2.5 text-base md:text-xl font-bold tracking-wide text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">@lilostellarcomms</p>
                                    </div>
                                </div>
                                <div class="flex">
                                    <div class="w-20">
                                        <img width="50" height="50" src="https://img.icons8.com/dotty/80/FFFFFF/twitter.png" alt="twitter" />
                                    </div>
                                    <div>
                                        <p class="pt-2.5 text-base md:text-xl font-bold tracking-wide text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">@lilostellar</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default Contact;